// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html body .sidenav---sidenav-nav---3tvij > .sidenav---sidenav-navitem---uwIJ-:hover,
html body .sidenav---sidenav-nav---3tvij > .sidenav---sidenav-navitem---uwIJ- {
  display: block;
  padding-bottom: 50px;
}

#root > div > div.App > div:nth-child(1) > nav > div:nth-child(2) > div.sidenav---sidenav-navitem---uwIJ-.sidenav---selected---1EK3y.sidenav---highlighted---oUx9u {
  padding-bottom: 46px;
  padding-top: 3px;
}

.chatlist-menu-options {
  color: #fff;
  padding-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Styles/sidebar.scss"],"names":[],"mappings":"AAAA;;EAEE,cAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;AACF","sourcesContent":["html body .sidenav---sidenav-nav---3tvij > .sidenav---sidenav-navitem---uwIJ-:hover,\nhtml body .sidenav---sidenav-nav---3tvij > .sidenav---sidenav-navitem---uwIJ- {\n  display: block;\n  padding-bottom: 50px;\n}\n\n#root > div > div.App > div:nth-child(1) > nav > div:nth-child(2) > div.sidenav---sidenav-navitem---uwIJ-.sidenav---selected---1EK3y.sidenav---highlighted---oUx9u {\n  padding-bottom: 46px;\n  padding-top: 3px;\n}\n\n.chatlist-menu-options {\n  color: #fff;\n  padding-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
